
export * from './src/implementations/repo/MemoRepo'
export * from './src/implementations/repo/ReactiveNodeActor'
export * from './src/implementations/branch/BranchIoMemory'
export * from './src/implementations/page/PageIoMemory'
export * from './src/implementations/page/PageStore'
export * from './src/implementations/repo/RepoSyncAgent'

export * from './src/sync-api-definition/sync-api-definition'

export * from './src/node-walker'


export * from './src/primatives/hash-primatives'
export * from './src/primatives/page-primatives'
export * from './src/primatives/repo-primatives'
export * from './src/primatives/graph-primitives'

export * from './src/key-interfaces/IPageIo'
export * from './src/key-interfaces/IBranchIo'
export * from './src/key-interfaces/IPageStore'
export * from './src/key-interfaces/IMemoRepo'
export * from './src/key-interfaces/IRepoService'

export * from './src/implementations/diff/difference'
export * from './src/implementations/diff/diff-kit'

export * from './src/rxjs/rxjs-kit'

        import * as me from '@peachy/memorepo-pure'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/memorepo/pure'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/memorepo-pure'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    